import React, { useEffect, lazy, Suspense } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import Layout from "../Admin/Layout";
import Maintenance from "../pages/Maintenance";

// Lazy-loaded components for the Admin panel
const AdminDashboard = lazy(() => import("../Admin/AdminDashboard"));
const Category = lazy(() => import("../Admin/Category"));
const Game = lazy(() => import("../Admin/Game"));
const TermsConditions = lazy(() => import("../Admin/TermsConditions"));
const PrivacyPolicy = lazy(() => import("../Admin/PrivacyPolicy"));
const User = lazy(() => import("../Admin/User"));
const Contact = lazy(() => import("../Admin/Contact"));
const Blog = lazy(() => import("../Admin/Blog"));
const AdminProfile = lazy(() => import("../Admin/AdminProfile"));
const Faq = lazy(() => import("../Admin/Faq"));
const Transaction = lazy(() => import("../Admin/Transaction"));
const Subscriber = lazy(() => import("../Admin/Subscriber"));
const Discounts = lazy(() => import("../Admin/Discounts"));
const AdminBundles = lazy(() => import("../Admin/AdminBundles"));
const NotFound = lazy(() => import("../Admin/NotFound"));


const AdminRoutes = () => {
  const navigate = useNavigate();
  const role = localStorage.getItem('role');
  const isMaintenanceMode = false; // Toggle this

  // ✅ Hook 1
  useEffect(() => {
    document.title = `Admin • YOYO`;
    window.scrollTo(0, 0);
  }, []);

  // ✅ Hook 2
  useEffect(() => {
    if (!isMaintenanceMode && role !== 'admin') {
      navigate('/');
    }
  }, [role, isMaintenanceMode, navigate]);

  // ✅ Conditional return AFTER hooks
  if (isMaintenanceMode) {
    return (
      <Routes>
        <Route path="*" element={<Maintenance />} />
      </Routes>
    );
  }

  return (
    <Layout>
      <Suspense>
        <Routes>
          <Route path="/" element={<AdminDashboard />} />
          <Route path="/category" element={<Category />} />
          <Route path="/games" element={<Game />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/user" element={<User />} />
          <Route path="/profile" element={<AdminProfile />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/bundles" element={<AdminBundles />} />
          <Route path="/order" element={<Transaction />} />
          <Route path="/subscriber" element={<Subscriber />} />
          <Route path="/discounts" element={<Discounts />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Layout>
  );
};

export default AdminRoutes;
